import { Flex } from 'antd';
import styles from './conversation-header.module.scss';
import TopicChip from '../topic-chip/topic-chip';

interface ConversationHeaderProps {
  phone: string;
  id: number;
  topic: string[];
  summary: string;
  detectedTags: string[];
  isSms?: boolean;
}

export const ConversationHeader = ({
  phone,
  id,
  topic,
  summary,
  detectedTags,
  isSms = false,
}: ConversationHeaderProps) => {
  return (
    <Flex gap={15} className={styles.headerContainer}>
      <Flex gap={4} vertical className={styles.firstColumn}>
        <p className={styles.heading}>ID</p>
        <p className={styles.boldText}>{phone}</p>
        <p className={styles.callId}>[{id}]</p>
      </Flex>
      <Flex gap={4} vertical className={styles.secondColumn}>
        <p className={styles.heading}>Topic</p>
        <div className={styles.topicContainer}>
          {topic.length > 0
            ? [...new Set(topic)].map((item, index, array) => (
                <p className={styles.boldText} key={index}>
                  {item}
                  {index !== array.length - 1 && ','}
                </p>
              ))
            : 'N/A'}
        </div>
      </Flex>
      <Flex gap={4} vertical className={styles.thirdColumn}>
        <p className={styles.heading}>{isSms ? 'Summary' : 'Call summary'} </p>
        <p className={styles.summary}>{summary || 'N/A'}</p>
      </Flex>
      <Flex gap={4} vertical className={styles.fourthColumn}>
        <p className={styles.heading}>Detected tags</p>
        <Flex gap={4} wrap className={styles.topicColumn}>
          {detectedTags.length > 0
            ? [...new Set(detectedTags)].map((title) => (
                <TopicChip
                  className={styles.chip}
                  title={title}
                  variant={title === 'Other' ? 'secondary' : 'primary'}
                  key={title}
                />
              ))
            : 'N/A'}
        </Flex>
      </Flex>
    </Flex>
  );
};
